import { z } from 'zod/v4';
import { TemplateItemSchema } from './template-item.js';

export const ListTemplatesQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0),
  count: z.coerce.number().int().min(1).max(500).default(15),
  sort: z.string().optional(),
  name: z.string().optional(),
});

export type ListTemplatesQuery = z.infer<typeof ListTemplatesQuerySchema>;

export const ListTemplatesResponseSchema = z.object({
  data: z.array(TemplateItemSchema),
  meta: z.object({
    count: z.number(),
    page: z.number(),
    pageSize: z.number(),
    totalCount: z.number(),
  }),
});

export type ListTemplatesResponse = z.infer<typeof ListTemplatesResponseSchema>;
